import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var SortDesc = createReactComponent("SortDesc", ["svg", defaultAttributes, [["path", {
  d: "M11 5h4",
  key: "3q0uf9"
}], ["path", {
  d: "M11 9h7",
  key: "ktv0sq"
}], ["path", {
  d: "M11 13h10",
  key: "59ep1j"
}], ["path", {
  d: "M3 17l3 3 3-3",
  key: "1rwooe"
}], ["path", {
  d: "M6 18V4",
  key: "13cxt6"
}]]]);
export default SortDesc;